<template>
  <div
    class="d-flex align-items-center justify-content-center"
    style="min-height: 600px;"
  >
    <img
      class="img-margin"
      style="max-height: 500px; max-width: 450px;"
      :src="imageLink"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "side-image",
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink"
    })
  }
};
</script>

<style scoped>
.img-margin {
  margin: 0 auto !important;
}
</style>
